import { useEffect, useCallback } from "react";
import NotificationService from "../utils/notificationService";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "../store";

const NotificationCenter = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const handleNewNotification = useCallback((notification) => {
    console.log("📨 Nouvelle notification reçue:", notification);
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;

    const service = new NotificationService(handleNewNotification);
    service.start();

    return () => {
      service.close();
    };
  }, [isAuthenticated, handleNewNotification]);

  return null;
};

export default NotificationCenter;